import { ApiConfig } from 'src/app/shared/api-config/api-config';
import { environment } from 'src/environments/environment';
import { MockMapsWrapperModule } from './google-maps/mock.maps-wrapper';
import { MockHickoryApiModule } from './mock.hickory-api.module';
import { AppEnv } from 'src/app/app.config';

export class MockModules {
  static readonly mockModules = environment.env === AppEnv.mock ? [
    MockHickoryApiModule.forRoot(ApiConfig.hickoryConfigFactory),
    MockMapsWrapperModule.forRoot({ apiKey: 'test', libraries: ['places'], }),
  ] : [];
}